"use client";

import { Dots } from "@/public/assets";
import { ApplyForJob, FindTalent } from "@/components";

const WorkForceRecruiting = () => {
  return (
    <div className="px-4 py-12 sm:px-6 lg:px-8">
      <div className="bg-[#151515] text-white rounded-lg overflow-hidden max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row">
          <div className="p-6 md:p-8 flex flex-col justify-center md:max-w-[60%]">
            <h1 className="text-2xl md:text-3xl font-medium mb-2  ">
              Ready to <br />
              <span className="text-[#1FC16B] italic">Build</span> Your
              workforce?
            </h1>
            <p className="text-sm md:text-base mb-6  ">
              Don’t let your hiring process overwhelm you. Let Cotton’s
              professionals handle it with ease.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 mb-6 sm:mb-8 max-w-lg">
              <FindTalent />
              <ApplyForJob className="text-foreground-600 bg-white border-0" />
              {/* <TrackService /> */}
            </div>
          </div>
          <div className="relative flex-1 min-h-[160px]">
            <img
              alt="dots"
              className="absolute right-0 top-10 h-full"
              src={Dots.src}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkForceRecruiting;
